import script from "./order-item.vue?vue&type=script&setup=true&lang=js"
export * from "./order-item.vue?vue&type=script&setup=true&lang=js"

import "./order-item.vue?vue&type=style&index=0&id=982e6d46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-982e6d46"]])

export default __exports__